<mat-card class="p-0">
    <mat-tab-group (selectedTabChange)="onTabChanged($event)">
        <mat-tab label="Immigration Details"> 
            <div class="row bg-white p-0">
                <div class="col-12 p-0 pt-4 pb-2">
                    <div class="container p-2" *ngIf="!viewMode">
                        <form (click)="trackNonImmigrantVisaForm(nonImmigrantVisForm)" #nonImmigrantVisForm="ngForm">
                            <h5 class="inner-heading mb-4">Immigrant/Non-Immigrant Visa Info</h5>
                            <div *ngIf="showEditButton">
                            <div class="row align-items-center">
                                <div class="col-md-7 p-0 mb-3">Have you ever applied for any US immigrant/non-immigrant visa?</div>
                                <div class="col-md-5">
                                <mat-radio-group (change)="handleToggle()" name="neverAppliedFlag"
                                    aria-labelledby="example-radio-group-label" class="example-radio-group has-immigration" [(ngModel)]="neverAppliedFlag">
                                    <mat-radio-button class="example-radio-button" value="Yes">
                                    Yes
                                    </mat-radio-button>
                                    <mat-radio-button class="example-radio-button" value="No">
                                    No
                                    </mat-radio-button>
                                </mat-radio-group>
                                </div>
                            </div>
                            <div class="row col-md-12">
                                <label *ngIf="neverAppliedFlag === 'No'">
                                Thank you for your response. You do not have to enter any further
                                details.
                                </label>
                            </div>
                            <div *ngIf="iscaseRequest ? (currentItemDisplay.includes('VISADTLS') ? true: false) : true">
                                <div class="row align-items-center" *ngIf="expandPanel">
                                <div class="form-group col-md-8 p-0">
                                    <label>Alien Registration Number</label>
                                    <input class="im-input mb-2" type="text" name="alienRegNumber" [(ngModel)]="visaMeta.alienRegNo"
                                    placeholder="Enter" #alienRegNumber="ngModel" [disabled]="visaMeta.hasAlienRegnNo" />
                                </div>
                                <div class="form-group col-md-4" style="margin-bottom: 0">
                                    <mat-checkbox name="alienRegNumberNA" (change)="updateAlienNo()" [(ngModel)]="visaMeta.hasAlienRegnNo">
                                    Not Applicable
                                    </mat-checkbox>
                                </div>
                                </div>
                            </div>
                            
                            <div class="row">
                                <div *ngIf="beneficiaryType == 'self'">
                                <div *ngFor="let ques of customQuestions?.sectionList">
                                    <div *ngIf="ques.name == 'Immigration Details'">
                                    <div class="customSections" *ngFor="let item of ques.stakeHoldersSelected">
                                        <div *ngIf="(item?.key == 'QTPROFILEBEN') && item.selected == true"> 
                                        <app-custom-questions 
                                            [isNewPortion]="false" 
                                            [viewQuestions]="false" 
                                            [loadedIn]="'Immigration Details'" 
                                            [beneficiaryId]="beneficiaryId" 
                                            [isSection]="true"
                                            [familyId]="familyId"
                                            (refreshList)="onRefreshPage($event)"
                                            ></app-custom-questions>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                </div>
                                <div *ngIf="beneficiaryType !== 'self'">
                                <div *ngFor="let ques of customQuestions?.sectionList">
                                    <div *ngIf="ques.name == 'Immigration Details'">
                                    <div class="customSections" *ngFor="let item of ques.stakeHoldersSelected">
                                        <div *ngIf="(selectedUser?.dependentType?.code == item.key) && item.selected == true"> 
                                        <app-custom-questions 
                                            [isNewPortion]="false" 
                                            [viewQuestions]="false" 
                                            [loadedIn]="'Immigration Details'" 
                                            [beneficiaryId]="beneficiaryId" 
                                            [isSection]="true"
                                            [familyId]="familyId"
                                            (refreshList)="onRefreshPage($event)"
                                            ></app-custom-questions>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                    
                            <div class="row col-md-12 p-0">
                                <!-- IM-3956 Alien Registration Number* -->
                                <button type="button" class="btn btn-primary" (click)="saveVisaMetaInfo(nonImmigrantVisForm)">
                                    <i class="fa fa-save"></i> Save 
                                </button>
                            </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Visa Details" *ngIf="neverAppliedFlag === 'Yes'"> 
            <div class="row bg-white p-4">
                <div class="col-md-12 p-0 mt-4">
                    <button class="btn btn-outline-primary mb-2 add-visa-details" type="button" (click)="addVisaDetails()">
                        Add Visa Details
                        <i class="fa fa-chevron-down"></i>
                    </button>
                </div>
                <div class="col-md-12 p-4 add-visa-details-form-container" *ngIf="showVisaDetailsForm">
                    <form (click)="visaFormCheck(visaDetailsForm)" class="mt-2"
                        (ngSubmit)="saveVisaDetails(visaDetailsForm)" #visaDetailsForm="ngForm"
                        (change)="visaFormCheck(visaDetailsForm)">
                        <!-- IM-3831 : For able to save visa details -->
                        <div class="row" *ngIf="!iscaseRequest">
                            <div *ngIf="!checkPetitionName()" class="form-group col-md-6">
                                <label class="label-cls">What is the Petitioner Name? <span class="label-help-text">(Company)</span>
                                </label>
                                <input class="im-input mw-100 m-0" type="text" name="companyName" [(ngModel)]="visa.companyName"
                                placeholder="Enter" #companyName="ngModel" />                  
                            </div>
                        </div>
                        <div class="row" *ngIf="iscaseRequest ? (currentItemDisplay.includes('VISADTLS') ? true: false) : false">
                            <div *ngIf="!checkPetitionName()" class="form-group col-md-6">
                                <label class="label-cls">What is the Petitioner Name? <span class="label-help-text">(Company)</span></label>
                                <input class="im-input mw-100 m-0" type="text" name="companyName" [(ngModel)]="visa.companyName"
                                placeholder="Enter" #companyName="ngModel" />
                            </div>
                        </div>
                        <div class="row">
                        <div class="form-group col-md-6" *ngIf="!iscaseRequest">
                            <label class="label-cls">Which Visa did you apply for? <span class="label-help-text">(Visa Type)</span></label>
                            <p-dropdown (onChange)="handleVisaTypeChange(visa.immigrationStatusCode, visaDetailsForm);resetPetitionTypeDropDown()" [options]="visaTypeList" name="immigrationStatusCode" [(ngModel)]="visa.immigrationStatusCode" optionValue="code" optionLabel="name" placeholder="Select" #immigrationStatusCode="ngModel" class="w-100" [filter]="true" filterBy="name">
                            </p-dropdown>               
                        </div>
                        <div class="form-group col-md-6" *ngIf="iscaseRequest ? (currentItemDisplay.includes('VISADTLS') ? true: false) : false">
                            <label class="label-cls">Which Visa did you apply for? <span class="label-help-text">(Petition Type)</span></label>
                            <p-dropdown (onChange)="handleVisaTypeChange(visa.immigrationStatusCode, visaDetailsForm);resetPetitionTypeDropDown()" [options]="visaTypeList" name="immigrationStatusCode" [(ngModel)]="visa.immigrationStatusCode" optionValue="code" optionLabel="name" placeholder="Select" #immigrationStatusCode="ngModel" class="w-100">
                            </p-dropdown>
                        </div>
                        <div class="form-group col-md-6" *ngIf="!iscaseRequest">
                            <label class="label-cls">What is the petition type? <span class="label-help-text">(Petition Type)</span></label>
                            <p-dropdown [options]="visaPetitionTypeList" name="petitionTypeCode" [(ngModel)]="visa.petitionTypeCode" optionValue="code" optionLabel="name" placeholder="Select" #petitionTypeCode="ngModel" class="w-100">
                            </p-dropdown>                  
                        </div>
                        <div class="form-group col-md-6" *ngIf="iscaseRequest ? (currentItemDisplay.includes('VISADTLS') ? true: false) : false">
                            <label class="label-cls">What is the petition type? <span class="label-help-text">(Petition Type)</span></label>
                            <p-dropdown [options]="visaPetitionTypeList" name="petitionTypeCode" [(ngModel)]="visa.petitionTypeCode" optionValue="code" optionLabel="name" placeholder="Select" #petitionTypeCode="ngModel" class="w-100">
                            </p-dropdown>
                        </div>
                        </div>
                        <!-- IM-3831 : For able to save visa details -->
                        <div class="row" *ngIf="iscaseRequest ? (currentItemDisplay.includes('VISADTLS') ? true: false) : true">
                        <div *ngIf="checkPetitionName()" class="form-group col-md-6">
                            <label class="label-cls">What is the Petitioner Name?</label>
                            <input class="im-input mw-100 m-0" type="text" name="companyName" [(ngModel)]="visa.companyName"
                            placeholder="Enter" #companyName="ngModel" />
                        </div>
                        </div>
                        <div class="row" *ngIf="!iscaseRequest">
                        <div class="form-group col-md-12">
                            <label class="label-cls d-block">What is the visa outcome?</label>
                            <mat-radio-group aria-label="Select an option" name="outcome"
                            (change)="outcomeCodeIdChange()" [(ngModel)]="visa.outcomeIdCode" #outcomeIdCode="ngModel">
                            <mat-radio-button class="example-radio-button" *ngFor="let option of outcomeTypeList"
                                [value]="option.code">
                                {{ option.name }}
                            </mat-radio-button>
                            </mat-radio-group>                 
                        </div>
                        </div>
                        <div class="row" *ngIf="iscaseRequest">
                        <div class="form-group col-md-12">
                            <label class="label-cls d-block">What is the visa outcome?</label>
                            <mat-radio-group aria-label="Select an option" name="outcome"
                            (change)="outcomeCodeIdChange()" [(ngModel)]="visa.outcomeIdCode" #outcomeIdCode="ngModel">
                            <mat-radio-button class="example-radio-button" *ngFor="let option of outcomeTypeList"
                                [value]="option.code">
                                {{ option.name }}
                            </mat-radio-button>
                            </mat-radio-group>
                        </div>
                        </div>
                        <div class="row">
                        <div class="col-md-12 pt-2">
                            <mat-divider></mat-divider>
                        </div>
                        </div>
                        <div class="row">
                        <div class="col-md-12 pt-2">
                            <h5 class="labelText">Enter visa details</h5>
                        </div>
                        </div>
                        <div class="row pt-2">
                        <div class="form-group col-md-6" *ngIf="!iscaseRequest">
                            <label class="label-cls">USCIS Receipt Number</label>
                            <input class="im-input mw-100 m-0" type="text" name="noticeNo" [(ngModel)]="visa.noticeNo"
                            placeholder="Enter" #noticeNo="ngModel" pattern="^[A-Za-z0-9]+$" />
                            <mat-hint class="hint-text">Alphanumeric Characters only *</mat-hint>
                            <mat-error>                    
                            <span class="invalid-message" *ngIf="
                                (noticeNo.touched || visaDetailsForm.submitted) &&
                                noticeNo.errors?.pattern">
                                {{ getGlobalErrorMessages("INVALID_FORMAT") }}
                            </span>
                            </mat-error>
                        </div>
                        <div class="form-group col-md-6" 
                        *ngIf="iscaseRequest ? (currentItemDisplay.includes('VISADTLS') ? true: false): false">
                            <label class="label-cls">USCIS Receipt Number</label>
                            <input class="im-input mw-100 m-0" type="text" name="noticeNo" [(ngModel)]="visa.noticeNo"
                            placeholder="Enter" #noticeNo="ngModel" pattern="^[A-Za-z0-9]+$" />
                            <mat-hint class="hint-text">Alphanumeric Characters only *</mat-hint>                  
                        </div>
                        <div class="form-group col-md-6" *ngIf="!iscaseRequest">
                            <label class="label-cls">USCIS Receipt Date</label>
                            <mat-form-field appearance="outline" class="mt-0 date-field w-100">
                            <input matInput [matDatepicker]="receiptDtPicker" name="receiptDate" [max]="today"
                                #receiptDate="ngModel" [(ngModel)]="visa.receiptDate" placeholder="MM/DD/YYYY" (click)="receiptDtPicker.open()" />
                            <mat-datepicker-toggle matSuffix [for]="receiptDtPicker">
                            </mat-datepicker-toggle>
                            <mat-datepicker #receiptDtPicker></mat-datepicker>
                            </mat-form-field>                  
                        </div>
                        <div class="form-group col-md-6" 
                        *ngIf="iscaseRequest ? (currentItemDisplay.includes('VISADTLS') ? true: false) : false">
                            <label class="label-cls">USCIS Receipt Date</label>
                            <mat-form-field appearance="outline" class="mt-0 date-field">
                            <input matInput [matDatepicker]="receiptDtPicker" name="receiptDate" [max]="today"
                                #receiptDate="ngModel" [(ngModel)]="visa.receiptDate" placeholder="MM/DD/YYYY" (click)="receiptDtPicker.open()" />
                            <mat-datepicker-toggle matSuffix [for]="receiptDtPicker">
                            </mat-datepicker-toggle>
                            <mat-datepicker #receiptDtPicker></mat-datepicker>
                            </mat-form-field>
                        </div>
                        </div>
                        <!-- Denial  -->
                        <div class="container-fluid" *ngIf="visa.outcomeIdCode === 'VSADENY'"
                        style="padding-left: 0px; padding-right: 0px">
                        <div class="row">
                            <div class="form-group col-md-8" *ngIf="!iscaseRequest">
                            <label class="label-cls">Reason for denial</label>
                            <input class="im-input mb-2 mw-100" type="text" name="reasonForDenial"
                                [(ngModel)]="visa.outcomeReason" placeholder="Enter" #reasonForDenial="ngModel" />                    
                            </div>
                            <div class="form-group col-md-8"  *ngIf="iscaseRequest ? (currentItemDisplay.includes('VISADTLS') ? true: false) : false">
                            <label class="label-cls">Reason for denial</label>
                            <input class="im-input mb-2 mw-100" type="text" name="reasonForDenial"
                                [(ngModel)]="visa.outcomeReason" placeholder="Enter" #reasonForDenial="ngModel" />
                            </div>
                            <div class="form-group col-md-4" *ngIf="!iscaseRequest">
                            <label class="label-cls">Denial Date</label>
                            <mat-form-field appearance="outline" class="mt-0 date-field">
                                <input matInput [matDatepicker]="denialDtPicker" name="outcomeDate" [min]="visa.receiptDate"
                                [max]="today" [(ngModel)]="visa.outcomeDate" placeholder="MM/DD/YYYY" #outcomeDate="ngModel"
                                (click)="denialDtPicker.open()" />
                                <mat-datepicker-toggle matSuffix [for]="denialDtPicker">
                                </mat-datepicker-toggle>
                                <mat-datepicker #denialDtPicker></mat-datepicker>
                            </mat-form-field>                    
                            </div>
                            <div class="form-group col-md-4" *ngIf="iscaseRequest ? (currentItemDisplay.includes('VISADTLS') ? true: false) : false">
                            <label class="label-cls">Denial Date</label>
                            <mat-form-field appearance="outline" class="mt-0 date-field">
                                <input matInput [matDatepicker]="denialDtPicker" name="outcomeDate" [min]="visa.receiptDate"
                                [max]="today" [(ngModel)]="visa.outcomeDate" placeholder="MM/DD/YYYY" #outcomeDate="ngModel" (click)="denialDtPicker.open()" />
                                <mat-datepicker-toggle matSuffix [for]="denialDtPicker">
                                </mat-datepicker-toggle>
                                <mat-datepicker #denialDtPicker></mat-datepicker>
                            </mat-form-field>
                            </div>
                        </div>
                        </div>
                        <!-- APPROVED -->
                        <div class="container-fluid" *ngIf="visa.outcomeIdCode === 'VSAAPP'"
                        style="padding-left: 0px; padding-right: 0px">
                        <div class="row">
                            <div class="form-group col-md-4" *ngIf="!iscaseRequest">
                            <label class="label-cls">USCIS Approved Date</label>
                            <mat-form-field appearance="outline" class="mt-0 date-field">
                                <input matInput [matDatepicker]="approvedDtPicker" name="outcomeDate" [min]="visa.receiptDate"
                                [max]="today" #outcomeDate="ngModel" [(ngModel)]="visa.outcomeDate" placeholder="MM/DD/YYYY"
                                (click)="approvedDtPicker.open()" />
                                <mat-datepicker-toggle matSuffix [for]="approvedDtPicker">
                                </mat-datepicker-toggle>
                                <mat-datepicker #approvedDtPicker></mat-datepicker>
                            </mat-form-field>
                            </div>
                            <div class="form-group col-md-4" *ngIf="iscaseRequest ? (currentItemDisplay.includes('VISADTLS') ? true: false) : false">
                            <label class="label-cls">USCIS Approved Date</label>
                            <mat-form-field appearance="outline" class="mt-0 date-field">
                                <input matInput [matDatepicker]="approvedDtPicker" name="outcomeDate" [min]="visa.receiptDate"
                                [max]="today" #outcomeDate="ngModel" [(ngModel)]="visa.outcomeDate" placeholder="MM/DD/YYYY" (click)="approvedDtPicker.open()" />
                                <mat-datepicker-toggle matSuffix [for]="approvedDtPicker">
                                </mat-datepicker-toggle>
                                <mat-datepicker #approvedDtPicker></mat-datepicker>
                            </mat-form-field>
                            </div>
                            <div class="form-group col-md-4" *ngIf="!iscaseRequest">
                            <label class="label-cls">Visa Validity Start Date</label>
                            <mat-form-field appearance="outline" class="mt-0 date-field">
                                <!-- IM-3888 Visa validity start date can be future date. / Validity start date can be earlier than the approval date-->
                                <!-- IM-4040 Validity start date can be earlier than the approval date but not less than receipt date-->
                                <input matInput [matDatepicker]="valStartDtPicker" name="validityStartDate"
                                #validityStartDate="ngModel" [(ngModel)]="visa.validityStartDate" placeholder="MM/DD/YYYY"
                                (dateChange)="visaValidityStartChange()" [min]="visa.receiptDate"
                                (click)="valStartDtPicker.open()" />
                                <mat-datepicker-toggle matSuffix [for]="valStartDtPicker">
                                </mat-datepicker-toggle>
                                <mat-datepicker #valStartDtPicker></mat-datepicker>
                            </mat-form-field>                    
                            </div>
                            <div class="form-group col-md-4" *ngIf="iscaseRequest ? (currentItemDisplay.includes('VISADTLS') ? true: false) : false">
                            <label class="label-cls">Visa Validity Start Date</label>
                            <mat-form-field appearance="outline" class="mt-0 date-field">
                                <!-- IM-3888 Visa validity start date can be future date. / Validity start date can be earlier than the approval date-->
                                <!-- IM-4040 Validity start date can be earlier than the approval date but not less than receipt date-->
                                <input matInput [matDatepicker]="valStartDtPicker" name="validityStartDate"
                                #validityStartDate="ngModel" [(ngModel)]="visa.validityStartDate" placeholder="MM/DD/YYYY"
                                (dateChange)="visaValidityStartChange()" [min]="visa.receiptDate"
                                (click)="valStartDtPicker.open()" />
                                <mat-datepicker-toggle matSuffix [for]="valStartDtPicker">
                                </mat-datepicker-toggle>
                                <mat-datepicker #valStartDtPicker></mat-datepicker>
                            </mat-form-field>                   
                            </div>
                            <div class="form-group col-md-4" *ngIf="!iscaseRequest">
                            <label class="label-cls">Visa Validity End Date</label>
                            <mat-form-field appearance="outline" class="mt-0 date-field">
                                <input matInput [matDatepicker]="valEndDtPicker" name="validityEndDate"
                                [min]="minVisaValidityEndDate" #validityEndDate="ngModel" [(ngModel)]="visa.validityEndDate"
                                placeholder="MM/DD/YYYY" (click)="valEndDtPicker.open()" />
                                <mat-datepicker-toggle matSuffix [for]="valEndDtPicker">
                                </mat-datepicker-toggle>
                                <mat-datepicker #valEndDtPicker></mat-datepicker>
                            </mat-form-field>                    
                            </div>
                            <div class="form-group col-md-4" *ngIf="iscaseRequest ? (currentItemDisplay.includes('VISADTLS') ? true: false) : false">
                            <label class="label-cls">Visa Validity End Date</label>
                            <mat-form-field appearance="outline" class="mt-0 date-field">
                                <input matInput [matDatepicker]="valEndDtPicker" name="validityEndDate"
                                [min]="minVisaValidityEndDate" #validityEndDate="ngModel" [(ngModel)]="visa.validityEndDate"
                                placeholder="MM/DD/YYYY" (click)="valEndDtPicker.open()" />
                                <mat-datepicker-toggle matSuffix [for]="valEndDtPicker">
                                </mat-datepicker-toggle>
                                <mat-datepicker #valEndDtPicker></mat-datepicker>
                            </mat-form-field>                    
                            </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col-md-12">
                            <label class="label-cls"><strong>Did you go through Consular Process for Visa Stamping?</strong></label>
                            </div>
                            <div class="col-md-6">
                            <mat-radio-group name="visaStamping"
                                aria-labelledby="example-radio-group-label" class="example-radio-group"
                                [(ngModel)]="visa.visaStamping">
                                <mat-radio-button class="example-radio-button" [value]="true">
                                Yes
                                </mat-radio-button>
                                <mat-radio-button class="example-radio-button" [value]="false">
                                No
                                </mat-radio-button>
                            </mat-radio-group>
                            </div>
                        </div>


                        <div class="row" *ngIf="visa.visaStamping">
                            <div class="form-group col-md-6" *ngIf="!iscaseRequest">
                            <label class="label-cls">Visa Issue Date</label>
                            <mat-form-field appearance="outline" class="mt-0 date-field">
                                <input matInput [matDatepicker]="valVisaIssueDateDtPicker" name="visaIssueDate"
                                #visaIssueDate="ngModel" [(ngModel)]="visa.visaIssueDate" placeholder="MM/DD/YYYY"
                                (dateChange)="visaIssueDateChange()" [min]="visa.receiptDate"
                                (click)="valVisaIssueDateDtPicker.open()" />
                                <mat-datepicker-toggle matSuffix [for]="valVisaIssueDateDtPicker">
                                </mat-datepicker-toggle>
                                <mat-datepicker #valVisaIssueDateDtPicker></mat-datepicker>
                            </mat-form-field>                    
                            </div>
                            <div class="form-group col-md-6" *ngIf="iscaseRequest ? (currentItemDisplay.includes('VISADTLS') ? true: false) : false">
                            <label class="label-cls">Visa Issue Date</label>
                            <mat-form-field appearance="outline" class="mt-0 date-field">
                                <input matInput [matDatepicker]="valVisaIssueDateDtPicker" name="visaIssueDate"
                                #visaIssueDate="ngModel" [(ngModel)]="visa.visaIssueDate" placeholder="MM/DD/YYYY"
                                (dateChange)="visaIssueDateChange()" [min]="visa.receiptDate"
                                (click)="valVisaIssueDateDtPicker.open()" />
                                <mat-datepicker-toggle matSuffix [for]="valVisaIssueDateDtPicker">
                                </mat-datepicker-toggle>
                                <mat-datepicker #valVisaIssueDateDtPicker></mat-datepicker>
                            </mat-form-field>                    
                            </div>
                            <div class="form-group col-md-6" *ngIf="!iscaseRequest">
                            <label class="label-cls">Visa Expiration Date</label>
                            <mat-form-field appearance="outline" class="mt-0 date-field">
                                <input matInput [matDatepicker]="valVisaExpirationDateDtPicker" name="visaExpirationDate"
                                [min]="minVisaExpirationDate" #visaExpirationDate="ngModel" [(ngModel)]="visa.visaExpirationDate"
                                placeholder="MM/DD/YYYY" (click)="valVisaExpirationDateDtPicker.open()" />
                                <mat-datepicker-toggle matSuffix [for]="valVisaExpirationDateDtPicker">
                                </mat-datepicker-toggle>
                                <mat-datepicker #valVisaExpirationDateDtPicker></mat-datepicker>
                            </mat-form-field>                    
                            </div>
                            <div class="form-group col-md-6" *ngIf="iscaseRequest ? (currentItemDisplay.includes('VISADTLS') ? true: false) : false">
                            <label class="label-cls">Visa Expiration Date</label>
                            <mat-form-field appearance="outline" class="mt-0 date-field">
                                <input matInput [matDatepicker]="valVisaExpirationDateDtPicker" name="visaExpirationDate"
                                [min]="minVisaExpirationDate" #visaExpirationDate="ngModel" [(ngModel)]="visa.visaExpirationDate"
                                placeholder="MM/DD/YYYY" (click)="valVisaExpirationDateDtPicker.open()" />
                                <mat-datepicker-toggle matSuffix [for]="valVisaExpirationDateDtPicker">
                                </mat-datepicker-toggle>
                                <mat-datepicker #valVisaExpirationDateDtPicker></mat-datepicker>
                            </mat-form-field>                    
                            </div>
                        </div>



                        <div class="row align-items-center" *ngIf="!iscaseRequest">
                            <div class="form-group col-md-8">
                            <label class="label-cls">EAD Number</label>
                            <input [disabled]="visa.isEadNo" class="im-input mb-2 mw-100" type="text" name="eadNo"
                                [(ngModel)]="visa.eadNo" placeholder="Enter" #eadNo="ngModel" />                   
                            </div>
                            <div class="form-group col-md-4">
                            <mat-checkbox (change)="eadUpdate()" name="isEadNo" [(ngModel)]="visa.isEadNo">
                                Not Applicable
                            </mat-checkbox>
                            </div>
                        </div>
                        <div class="row align-items-center" *ngIf="iscaseRequest ? (currentItemDisplay.includes('VISADTLS') ? true: false) : false">
                            <div class="form-group col-md-8">
                            <label class="label-cls">EAD Number</label>
                            <input [disabled]="visa.isEadNo" class="im-input mb-2 mw-100" type="text" name="eadNo"
                                [(ngModel)]="visa.eadNo" placeholder="Enter" #eadNo="ngModel" />
                            </div>
                            <div class="form-group col-md-4">
                            <mat-checkbox (change)="eadUpdate()" name="isEadNo" [(ngModel)]="visa.isEadNo">
                                Not Applicable
                            </mat-checkbox>
                            </div>
                        </div>
                        <div class="row align-items-center" *ngIf="!iscaseRequest">
                            <div class="form-group col-md-8">
                            <label class="label-cls">SEVIS Number</label>
                            <input class="im-input mb-2 mw-100" type="text" name="sevisNo" [disabled]="visa.isSevisNo"
                                [(ngModel)]="visa.sevisNo" placeholder="Enter" #sevisNo="ngModel" />                    
                            </div>
                            <div class="form-group col-md-4">
                            <mat-checkbox (change)="sevisUpdate()" name="isSevisNo" [(ngModel)]="visa.isSevisNo"
                                [disabled]="isVisaTypeF1">
                                Not Applicable
                            </mat-checkbox>
                            </div>
                        </div>
                        <div class="row align-items-center" *ngIf="iscaseRequest ? (currentItemDisplay.includes('VISADTLS') ? true: false) : false">
                            <div class="form-group col-md-8">
                            <label class="label-cls">SEVIS Number</label>
                            <input class="im-input mb-2 mw-100" type="text" name="sevisNo" [disabled]="visa.isSevisNo"
                                [(ngModel)]="visa.sevisNo" placeholder="Enter" #sevisNo="ngModel" />
                            </div>
                            <div class="form-group col-md-4">
                            <mat-checkbox (change)="sevisUpdate()" name="isSevisNo" [(ngModel)]="visa.isSevisNo"
                                [disabled]="isVisaTypeF1">
                                Not Applicable
                            </mat-checkbox>
                            </div>
                        </div>
                        <div class="row align-items-center" *ngIf="iscaseRequest ? (currentItemDisplay.includes('VISADTLS') ? true: false) : true">
                            <div class="col-md-12">
                            <label class="label-cls">Have you used this visa?</label>
                            </div>
                            <div class="col-md-6">
                            <mat-radio-group name="hasTravelToUs" (change)="handleToggleHasTravelToUs()"
                                aria-labelledby="example-radio-group-label" class="example-radio-group"
                                [(ngModel)]="visa.hasTravelToUs">
                                <mat-radio-button class="example-radio-button" [value]="true">
                                Yes
                                </mat-radio-button>
                                <mat-radio-button class="example-radio-button" [value]="false">
                                No
                                </mat-radio-button>
                            </mat-radio-group>
                            </div>
                        </div>
                        </div>
                        <!-- WITHDRAWN -->
                        <div class="container-fluid" *ngIf="visa.outcomeIdCode === 'VSAWTDN'"
                        style="padding-left: 0px; padding-right: 0px">
                        <div class="row" *ngIf="!iscaseRequest">
                            <div class="form-group col-md-8">
                            <label class="label-cls">Reason for withdrawal</label>
                            <input class="im-input mb-2 mw-100" type="text" name="reasonForDenial"
                                [(ngModel)]="visa.outcomeReason" placeholder="Enter" #reasonForDenial="ngModel" />                    
                            </div>
                            <div class="form-group col-md-4">
                            <label class="label-cls">Withdrawal Date</label>
                            <mat-form-field appearance="outline" class="mt-0 date-field">
                                <input matInput [matDatepicker]="denialDtPicker" name="outcomeDate" [min]="visa.receiptDate"
                                [max]="today" #outcomeDate="ngModel" [(ngModel)]="visa.outcomeDate" 
                                placeholder="MM/DD/YYYY" (click)="denialDtPicker.open()" />
                                <mat-datepicker-toggle matSuffix [for]="denialDtPicker">
                                </mat-datepicker-toggle>
                                <mat-datepicker #denialDtPicker></mat-datepicker>
                            </mat-form-field>                    
                            </div>
                        </div>
                        <div class="row" *ngIf="iscaseRequest ? (currentItemDisplay.includes('VISADTLS') ? true: false) : false">
                            <div class="form-group col-md-8">
                            <label class="label-cls">Reason for withdrawal</label>
                            <input class="im-input mb-2 mw-100" type="text" name="reasonForDenial"
                                [(ngModel)]="visa.outcomeReason" placeholder="Enter" #reasonForDenial="ngModel" />
                            </div>
                            <div class="form-group col-md-4">
                            <label class="label-cls">Withdrawal Date</label>
                            <mat-form-field appearance="outline" class="mt-0 date-field">
                                <input matInput [matDatepicker]="denialDtPicker" name="outcomeDate" [min]="visa.receiptDate"
                                [max]="today" #outcomeDate="ngModel" [(ngModel)]="visa.outcomeDate" 
                                placeholder="MM/DD/YYYY" (click)="denialDtPicker.open()" />
                                <mat-datepicker-toggle matSuffix [for]="denialDtPicker">
                                </mat-datepicker-toggle>
                                <mat-datepicker #denialDtPicker></mat-datepicker>
                            </mat-form-field>
                            </div>
                        </div>
                        </div>
                        <div class="row" *ngIf="iscaseRequest ? (currentItemDisplay.includes('VISADTLS') ? true: false) : true">
                        <div class="col-md-12 form-group">
                            <mat-checkbox (change)="updateCurrentlyUS()" name="currentlyStayInUS"
                            [(ngModel)]="visa.currentlyStayInUS">
                            Currently in the U.S
                            </mat-checkbox>
                        </div>
                        </div>              
                        <div class="next-btn">                
                        <hr />              
                        <div class="d-flex flex-row-reverse">
                            <div class="p-2">
                            <!-- <button type="button" class="btn btn-primary" matStepperNext [disabled]="!hasID">
                                Next
                            </button> -->
                            </div>
                            <!-- IM-3933 : Beneficiary Profile- Immigration section- Click on Add/Edit immigration button -->
                            <div class="p-2">
                            <button *ngIf="!modeVal" type="button" class="button_bg-gray" (click)="closeForm(visaDetailsForm)">
                                Close
                            </button>
                            </div>
                            <div class="p-2">
                            <button type="submit" [disabled]="visaDetailsForm.invalid" class="btn btn-success">
                                Save
                            </button>
                            </div>
                        </div>
                        </div>
                    </form>
                </div>

                <div class="table-section">Visa History</div>
                <div class="col-md-12 p-0 spacing im-card-no-border-table" [ngClass]="{disabledView: isViewMode}" *ngIf=" (isListView && neverAppliedFlag === 'Yes') ||(isListView && dataSource.data.length > 0) ">
                    
                    <table mat-table #table [dataSource]="dataSource" class="full-width-table" matSort aria-label="Elements">
                        
                        <ng-container matColumnDef="immigrationStatusCode">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Visa</th>
                            <td mat-cell *matCellDef="let row">{{row.immigrationStatusCode}}</td>
                        </ng-container>  
                        
                        <ng-container matColumnDef="petitionTypeCode">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Petition</th>
                            <td mat-cell *matCellDef="let row">{{row.petitionTypeCode}}</td>
                        </ng-container>
                        
                        <ng-container matColumnDef="companyName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Petition Name</th>
                            <td mat-cell *matCellDef="let row">{{row.companyName}}</td>
                        </ng-container>
                        
                        <ng-container matColumnDef="visaStatus">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Visa Status</th>
                            <td mat-cell *matCellDef="let row">{{row.visaStatus}}</td>
                        </ng-container>
                        
                        <ng-container matColumnDef="noticeNo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Receipt Number</th>
                            <td mat-cell *matCellDef="let row">{{row.noticeNo}}</td>
                        </ng-container>
                        
                        <ng-container matColumnDef="receiptDate">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Receipt Date</th>
                            <td mat-cell *matCellDef="let row">{{row?.receiptDate ? (row.receiptDate | ImgDateFormat) : '--'}}</td>
                        </ng-container>
                        
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
                            <td mat-cell *matCellDef="let row">
                                <i class="fa fa-pencil" aria-hidden="true" title="Edit" (click)="editImmigration(row)"></i>
                                <i class="fa fa-trash-o" aria-hidden="true" title="Delete" (click)="deleteImmigration(row)"></i>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    </table>  

                    <div class="no-record" *ngIf="dataSource && dataSource.data.length == 0">No record found</div>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="U.S Stay History" *ngIf="neverAppliedFlag === 'Yes'">
            <div class="row bg-white p-0">
                <div class="col-12 p-4">
                    <form [formGroup]="stayHistoryForm">
                        <ng-container formArrayName="items">
                          <table mat-table [dataSource]="stayHistoryDataSource" class="us-stay-hisroty-table">

                            <!-- Immigration Status Code Column -->
                            <ng-container matColumnDef="immigrationStatusCode">
                                <th mat-header-cell *matHeaderCellDef>Visa Type</th>
                                <td mat-cell *matCellDef="let element; let i = index" [formGroup]="stayHistoryForm.get('items')['controls'][i]">
                                  <p-dropdown appendTo="body" [options]="visaTypeList" formControlName="immigrationStatusCode" optionValue="code" optionLabel="name" [filter]="true" filterBy="name" (onChange)="updateFormControls(stayHistoryForm.get('items')['controls'][i])"></p-dropdown>
                                </td>
                            </ng-container>
                      
                            <!-- Petition Type Code Column -->
                            <ng-container matColumnDef="petitionTypeCode">
                                <th mat-header-cell *matHeaderCellDef>Petition Type</th>
                                <td mat-cell *matCellDef="let element; let i = index" [formGroup]="stayHistoryForm.get('items')['controls'][i]">
                                  <p-dropdown appendTo="body" [options]="petitionTypeList" formControlName="petitionTypeCode" optionValue="code" optionLabel="name" ></p-dropdown>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="i94Number">
                                <th mat-header-cell *matHeaderCellDef style="width:150px;">i94 Number</th>
                                <td mat-cell *matCellDef="let element; let i = index" [formGroup]="stayHistoryForm.get('items')['controls'][i]">
                                    <div formArrayName="travelInfo">
                                        <ng-container *ngFor="let eachTravelInfo of getTravelInfoArray(i)['controls']; let j=index">
                                            <div [formGroupName]="j">
                                                <input class="im-input m-0 mw-100" type="text" formControlName="i94Number" placeholder="Enter" maxlength="11" />
                                            </div>
                                        </ng-container>
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="i94ExpiryDate">
                                <th mat-header-cell *matHeaderCellDef style="width:150px;">Expiry Date</th>
                                <td mat-cell *matCellDef="let element; let i = index" [formGroup]="stayHistoryForm.get('items')['controls'][i]">
                                    <div formArrayName="travelInfo">
                                        <ng-container *ngFor="let eachTravelInfo of getTravelInfoArray(i)['controls']; let j=index">
                                            <div class="mb-2 iterative-column" [formGroupName]="j">
                                                <ng-container *ngIf="stayHistoryForm.get('items')['controls'][i].get('immigrationStatusCode').value === 'F1'">
                                                    <input class="im-input mb-2 mw-100" type="text" formControlName="durationOfStatus" placeholder="Enter" />
                                                </ng-container>
                                                <ng-container *ngIf="stayHistoryForm.get('items')['controls'][i].get('immigrationStatusCode').value !== 'F1'">
                                                    <p-calendar appendTo="body" formControlName="i94ExpiryDate" name="date" styleClass="p-form-datepicker"
                                                dateFormat="mm/dd/yy" [minDate]="eachTravelInfo.get('arrivalDate').value" placeholder="MM/DD/YYYY" [showIcon]="true"
                                                [readonlyInput]="false" [monthNavigator]="true" [yearNavigator]="true" yearRange="{{fromYear}}:{{toYear}}"></p-calendar>
                                                </ng-container>
                                            </div>
                                        </ng-container>
                                    </div>
                                </td>
                            </ng-container>

                            <!-- Entry Date Column -->
                            <ng-container matColumnDef="arrivalDate">
                                <th mat-header-cell *matHeaderCellDef>Entry Date</th>
                                <td mat-cell *matCellDef="let element; let i = index" [formGroup]="stayHistoryForm.get('items')['controls'][i]">
                                    <div formArrayName="travelInfo">
                                        <ng-container *ngFor="let eachTravelInfo of getTravelInfoArray(i)['controls']; let j=index">
                                            <div class="mb-2 iterative-column" [formGroupName]="j" >
                                                <p-calendar appendTo="body" formControlName="arrivalDate" name="date" styleClass="p-form-datepicker" dateFormat="mm/dd/yy" [maxDate]="currentDate" placeholder="MM/DD/YYYY" [showIcon]="true" [readonlyInput]="false" [monthNavigator]="true" [yearNavigator]="true" yearRange="{{fromYear}}:{{toYear}}">
                                                </p-calendar>
                                            </div>
                                        </ng-container>
                                    </div>
                                    <button type="button" class="btn btn-outline-primary add-more-button" (click)="addTravelInfo(i)">Add More - Entry and Exit</button>
                                </td>
                            </ng-container>
                        
                            <!-- Exit Date Column -->
                            <ng-container matColumnDef="exitDate">
                                <th mat-header-cell *matHeaderCellDef>Exit Date</th>
                                <td mat-cell *matCellDef="let element; let i = index" [formGroup]="stayHistoryForm.get('items')['controls'][i]">
                                    <div formArrayName="travelInfo">
                                        <ng-container *ngFor="let eachTravelInfo of getTravelInfoArray(i)['controls']; let j=index">
                                            <div class="mb-2 iterative-column" [formGroupName]="j" >
                                                <p-calendar appendTo="body" formControlName="exitDate" name="date" styleClass="p-form-datepicker"
                                                dateFormat="mm/dd/yy" [minDate]="eachTravelInfo.get('arrivalDate').value" placeholder="MM/DD/YYYY" [showIcon]="true"
                                                [readonlyInput]="false" [monthNavigator]="true" [yearNavigator]="true" yearRange="{{fromYear}}:{{toYear}}">
                                            </p-calendar>
                                            </div>
                                        </ng-container>
                                    </div>
                                </td>
                            </ng-container>
                        
                            <!-- Exit Reason Column -->
                            <ng-container matColumnDef="exitReason">
                                <th mat-header-cell *matHeaderCellDef>Exit Reason</th>
                                <td mat-cell *matCellDef="let element; let i = index" [formGroup]="stayHistoryForm.get('items')['controls'][i]">
                                    <div formArrayName="travelInfo">
                                        <ng-container *ngFor="let eachTravelInfo of getTravelInfoArray(i)['controls']; let j=index">
                                            <div class="mb-2 iterative-column" [formGroupName]="j" >
                                                <p-dropdown appendTo="body" [autoDisplayFirst]="false" placeholder="Select a Reason"  [options]="exitReasonList" formControlName="exitReason" optionValue="code" optionLabel="name"></p-dropdown>
                                            </div>
                                        </ng-container>
                                    </div>
                                </td>
                            </ng-container>
                        
                            <!-- Other Reason Column -->
                            <ng-container matColumnDef="otherReason">
                                <th mat-header-cell *matHeaderCellDef>Other Reason</th>
                                <td mat-cell *matCellDef="let element; let i = index" [formGroup]="stayHistoryForm.get('items')['controls'][i]">
                                    <div formArrayName="travelInfo">
                                        <ng-container *ngFor="let eachTravelInfo of getTravelInfoArray(i)['controls']; let j=index">
                                            <div class="mb-2 iterative-column p-1" [formGroupName]="j" >
                                                <input *ngIf="eachTravelInfo.get('exitReason').value === 'OTHER'" matInput type="text" formControlName="otherReason" />
                                                <span *ngIf="eachTravelInfo.get('exitReason').value !== 'OTHER'"> -- </span>
                                            </div>
                                        </ng-container>
                                    </div>
                                </td>
                            </ng-container>

                      
                            <!-- Action Column -->
                            <ng-container matColumnDef="action">
                              <th mat-header-cell *matHeaderCellDef>Action</th>
                              <td mat-cell *matCellDef="let element; let i = index" [formGroup]="stayHistoryForm.get('items')['controls'][i]">
                                <div formArrayName="travelInfo">
                                    <ng-container *ngFor="let eachTravelInfo of getTravelInfoArray(i)['controls']; let j=index">
                                        <div class="mb-2 iterative-column p-1" [formGroupName]="j" >
                                            <i class="fa fa-trash" title="This delete will only delete the travel record. Same visa record has to be deleted explicitly" (click)="deleteRow(i, j)"></i>
                                        </div>
                                    </ng-container>
                                </div>
                              </td>
                            </ng-container>
                      
                            <!-- Column definitions -->
                            <tr mat-header-row *matHeaderRowDef="stayHistoryDisplayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: stayHistoryDisplayedColumns;"></tr>
                        </table>
                        <div class="no-record" *ngIf="stayHistoryDataSource && stayHistoryDataSource.data.length == 0">No record found</div>
                        <div class="row mt-4">
                            <button type="button" class="btn btn-primary mr-4" (click)="AddNewRow()">Add More</button>
                            <button type="button" class="btn btn-primary" (click)="saveStayHistory()"> Save </button>
                        </div>
                        </ng-container>
                    </form>
                                         
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Upload Documents" *ngIf="neverAppliedFlag === 'Yes'" [disabled]="!configurations.entityId">
            <div class="row bg-white p-0">
                <div class="col-12 p-4">
                    <p class="p-3 m-0 pb-0"><b>Upload supporting documents</b></p>
                    <div class="row formBox">
                        <div class="col-md-12 mt-2">
                            <app-file-upload style="width: 100%" [configurations]="configurations"
                            (fileUploadSuccess)="fileUploadSuccess()">
                            </app-file-upload>
                        </div>
                    </div>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
</mat-card>
